import classNames from 'classnames';
import { FC } from 'react';

import { P1 } from '@zooplus/ui-components';

import Ellipsis, { EllipsisContainer } from '../Ellipsis/Ellipsis';
import MaskedCreditCardNumber from '../MaskedCreditCardNumber/MaskedCreditCardNumber';

import { CreditCardData } from '@types-internal';

import styles from './CreditCardInfo.module.scss';

const CreditCardInfo: FC<{
  brand?: string | null;
  isBancontactCard?: boolean | null;
  lastFourDigits?: CreditCardData['lastFourDigits'];
  expirationMonth?: CreditCardData['expirationMonth'];
  expirationYear?: CreditCardData['expirationYear'];
  creditCardHolderName?: string | null;
  inline?: boolean;
  expired?: boolean;
}> = ({
  lastFourDigits,
  expirationMonth,
  expirationYear,
  creditCardHolderName,
  isBancontactCard,
  brand,
  inline,
  expired = false,
}) => {
  const expirationYearLength = expirationYear?.length || 0;
  if (![2, 4].includes(expirationYearLength)) expirationYear = null;
  else if (expirationYear?.length === 4) expirationYear = `${expirationYear}`.substring(2, 4);
  const theme = inline ? 'dark' : 'default';

  return (
    <div
      className={classNames(styles.creditCardInfoContainer, { [styles.inline]: inline })}
      data-testid={isBancontactCard && 'storedBancontactCard'}>
      <EllipsisContainer theme={theme}>
        {brand && <P1 className="preferredPaymentText">{brand.toLowerCase()}</P1>}
        <MaskedCreditCardNumber lastFourDigits={lastFourDigits} />
      </EllipsisContainer>
      {creditCardHolderName && <P1 className="preferredPaymentText">{creditCardHolderName}</P1>}

      <EllipsisContainer theme={theme}>
        <span className={classNames(styles.expirationContainer, { [styles.expired]: expired })}>
          {expirationMonth || <Ellipsis identifier="expirationMonth" amount={2} />}/
          {expirationYear || <Ellipsis identifier="expirationYear" amount={2} />}
        </span>
      </EllipsisContainer>
    </div>
  );
};

export default CreditCardInfo;
